import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Quotes} from '@app/common/interfaces/quotes';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  constructor(private httpClient: HttpClient) {
  }

  public getCurrency(): Observable<Quotes> {
    return this.httpClient.get<Quotes>('https://v6.exchangerate-api.com/v6/87f7a0743fd7111fcc57e309/latest/AMD');
  }

}
